export const internshipResume = {
  id: 'internship-resume',
  version: 2,
  renderer: 'enterprise',
  name: 'Internship Hunter Pro',
  layout: 'two-column',
  theme: 'modern-teal',
  persona: ['student'],
  atsLevel: 'B',
  scoreWeights: {
    ats: 30,
    visual: 35,
    executive: 10,
    student: 25
  },
  sectionOrder: ['personal-info', 'summary', 'projects', 'internships', 'experience', 'education', 'skills', 'languages'],
  components: {
    header: 'header-creative',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-sidebar'
  },
  metadata: {
    industry: ['Tech Companies', 'Media Agencies', 'Design Studios'],
    companies: ['Intel', 'Cisco', 'Samsung', 'Figma', 'Slack', 'Zoom', 'Salesforce'],
    ats: ['Lever', 'Greenhouse', 'Workday'],
    pages: { min: 1, max: 1, preferred: 1 },
    photo: true,
    icons: true,
    density: 'comfortable',
    columns: 2,
    experienceLevel: ['Student', 'Entry-level'],
    careerStage: 'Student',
    recommendedFor: ['College Interns', 'Design Apprentices', 'Summer Trainees'],
    avoidFor: ['C-Suite Executives', 'Tenured Academics', 'Traditional Government Officials'],
    dna: ['Visual-Teal', 'Creative-Student', 'Two-Column-Modern', 'Structured-Sidebar', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 91,
      scanningSpeed: 92,
      visualAppeal: 95
    },
    hiringManager: {
      firstImpression: "Motivated, organized, modern student candidate with hands-on capabilities",
      scanningStyle: "Two-column F-Pattern scanning sidebar skills and education first, then main body projects",
      preferredStructure: "Personal info, education and skills in sidebar; summary, projects and experiences in main body",
      dislikes: ["Wall of text paragraphs", "Dry print designs for creative tech companies", "No portfolio links"]
    },
    strategy: {
      goal: "Hook modern recruiters with a visually engaging sidebar design while listing core student projects",
      focus: "Technical tool proficiencies, university projects, and coding course modules",
      avoid: ["Traditional black-and-white print styles", "Dense experience text blocks"]
    },
    psychology: {
      coreTraits: ["Motivation", "Adaptability", "Modernity", "Growth-mindset"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: false,
      sidebar: true
    },
    aiPrompt: {
      writingStyle: "Focus on student projects, lab experiments, internship roles, and skills matches. Use active, modern language.",
      rewriteStyle: "Modern, crisp, project-focused"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'two-column': {
      component: 'two-column',
      slots: {
        header: ['personal-info'],
        sidebar: ['education', 'skills', 'languages'],
        main: ['summary', 'projects', 'internships', 'experience']
      },
      overrides: {
        '--layout-sidebar-width': '197px',
        '--layout-column-gap': '18px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '24pt',
    '--weight-display': '700',
    '--heading-text-transform': 'none',
    '--heading-weight': '600',
    '--border-thickness-heading': '2px',
    '--bullet-style': 'square',
    '--spacing-section-mb': '16px',
    '--spacing-item-mb': '10px',
    '--spacing-bullet-gap': '4px',
    '--color-text-main': '#2D3748',
    '--color-text-light': '#718096'
  }
};
export default internshipResume;
